import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { type ReactNode } from 'react';

import { ConfirmProvider } from '@/components/ConfirmProvider';
import { Toaster } from '@/components/ui/toast';
import { TooltipProvider } from '@/components/ui/tooltip';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
      },
    },
  });
}

interface AppProvidersProps {
  children: ReactNode;
  queryClient?: QueryClient;
}

export function AppProviders({ children, queryClient }: AppProvidersProps) {
  return (
    <QueryClientProvider client={queryClient ?? createQueryClient()}>
      <TooltipProvider>
        {/* Toaster 供 lib/toast 的 notifySaved 用（儲存成功一律走它） */}
        <Toaster>
          <ConfirmProvider>{children}</ConfirmProvider>
        </Toaster>
      </TooltipProvider>
    </QueryClientProvider>
  );
}
